$(function () {
    $('.nav-link').on('click', function (e) {
        if ($(this).attr('href') === window.location.pathname + window.location.hash) {
            e.preventDefault();
            navbarToggle();
            menuScroll();
            window.scrollTo(window.location.hash);
        }
    });
});

const navbarToggle = () => {
    $('.navbar-toggler').each(function() {
      $(this).toggleClass( 'collapsed' )
    });
    $('.collapse').slideToggle().toggleClass('active');
}

const menuScroll = () => {
    if(window.innerWidth < 767) {
        if($('.collapse').hasClass('active')) {
            window.scroll_position = $(window).scrollTop();
            $('body')
                .css('position', 'fixed')
                .css('overflow', 'hidden')
                .css('width', '100%');
        } else {
            $('body')
                .css('position', '')
                .css('overflow', '')
                .css('width', 'auto');
            $('html').scrollTop(window.scroll_position);
        }
    }
}

$(document).on( 'click', '.navbar-toggler', function() {
    navbarToggle();
    menuScroll();
});

$('.menu-user-icon').each( function() {
    $(this).prepend('<i class="far fa-user"></i>');
});
